// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"7c2f7d95","488":"14c8f576"}[chunkId] + ".chunk.js";
};